import '../css/index.css'
import '../css/calc-overlay.css'
import '../css/about.css'


const About = ({showAbout, setShowAbout, isDark}) => {

    return (
        
        <div className="about-content">
            <div className="about-header">
            <div className="calc-header-link" onClick={()=>setShowAbout(!showAbout)} style={{width:'34px',  transform:'rotateZ(45deg)', fontSize:'1.8em'}}>+</div> 
            </div>
            <div className="about-body">
                <h1>RenderTime.app</h1>

                <br/>

                <p>I decided to publish this tiny calculator that I used to have running on my local machine. <a href="https://instagram.com/vicver" target="_blank"  tabIndex="-1" title='@vicver' rel='noreferrer'>I'm a 3D motion designer</a> and I do this math almost every day, I thought maybe it's helpful to someone else.</p>
                <br></br>                
                <center><div className="about-footer">CHEERS <a href="https://instagram.com/vicver" target="_blank"  tabIndex="-1" title='@vicver' rel='noreferrer'>@VICVER</a></div></center>
                <br></br>    
                <div className="line"/>
                
                <p className="notes" style={{display:window.innerWidth<900?'none':'flex'}}>
                    <img src={isDark?'img/cube-true-dark.svg':'img/cube-true.svg'} alt="Animation preference" style={{height:'1.6em', marginRight:'1em'}}/>
                    Turn the 3D animation off if you want to save resources.
                </p>

                <p className="notes">
                    <img src={isDark?'img/calculator-dark.svg':'img/calculator-day.svg'} alt="Animation preference" style={{display:'inline', height:'1.6em', marginRight:'1em'}}/>
                    The calculation is approximate since the frames do not always take the same amount of time to render.
                </p>

                <p className="notes">
                    <img src={isDark?'img/bookmark-dark.svg':'img/bookmark-day.svg'} alt="Animation preference" style={{display:'inline', height:'1.6em', marginRight:'1em'}}/>
                   Cmnd+D  /  Ctrl+D
                </p>

                <p className="notes">
                    <img src={isDark?'img/email-dark.svg':'img/email-day.svg'} alt="Animation preference" style={{display:'inline', height:'1.6em', marginRight:'1em'}}/>
                    <span>Let me know how this could be better at <a href="mailto:hey@rendertime.app" target="_blank"  tabIndex="-1" title='@vicver' rel='noreferrer'>hey@rendertime.app</a></span>
                </p>
                <div className="line"/>
                <div className="toDo"><u>To Do:</u></div>
                <div className="toDo">•Multiple machines</div>
                    
            </div>
            <div className="about-footer">v.1.0</div>
                    
        </div>

    );
}
 
export default About;